import { useEffect, useState } from "react";
import { useAppDispatch, useAppSelector } from "../../../../lib/redux/hooks";
import { setLegalRepresentativeCreateRequestField, setLegalRepresentativeUpdateRequestField } from "../../../../pages/clienti/feature/legalRepresentative/slice";
import { OptionType, Province, Region, regioniProvinceMap, regions } from "../../../../utils";
import { provinceComuniMap } from "../../../../utils/listaComuni";
import { MadfarmInput } from "../../input/newInput";
import { MadfarmStaticSelect } from "../../select/newSelect/static";

interface Props {
  mode: "create" | "edit"
}

export function RappLegaleRecapiti({ mode }: Props) {
  const legalRapresentativeState = useAppSelector(state => state.legalRapresentative)
  const dispatch = useAppDispatch()

  const [rpProvinceOptions, setRpProvinceOptions] = useState<OptionType[]>([])
  const [rpComuneOptions, setRpComuneOptions] = useState<OptionType[]>([])
  const [selectedRpRegion, setSelectedRpRegion] = useState<OptionType | null>(null)
  const [selectedRpProvince, setSelectedRpProvince] = useState<OptionType | null>(null)

  const regionOptions: OptionType[] = Array.from(regioniProvinceMap.keys()).map(r => ({ value: r, label: r }))

  const handleRpRegionChange = (opt: OptionType | null) => {
    setSelectedRpRegion(opt)
    setSelectedRpProvince(null)
  }
  const handleRpProvinceChange = (opt: OptionType | null) => setSelectedRpProvince(opt)

  // useEffect(() => {
  //   const request = mode === "create" ? legalRapresentativeState.legalRepresentativeCreateRequest : legalRapresentativeState.legalRepresentativeUpdateRequest
  //   if (request.contactCountryRegion) {
  //     const found = regions.find((r: Region) => r.name === request.contactCountryRegion.toString())
  //     setRpProvinceOptions(found ? found.provinces.map((p: Province) => ({ value: p.code, label: p.name })) : [])
  //   }
  //   if (request.contactProvince) {
  //     const comuni = provinceComuniMap.get(request.contactProvince.toString()) || []
  //     setRpComuneOptions(comuni.map((c: string) => ({ value: c, label: c })))
  //   }
  // }, [legalRapresentativeState.legalRepresentativeCreateRequest, legalRapresentativeState.legalRepresentativeUpdateRequest, mode])

  const legatRepresentativeRequest = mode === "create" ? legalRapresentativeState.legalRepresentativeCreateRequest : legalRapresentativeState.legalRepresentativeUpdateRequest

  useEffect(() => {
    if (selectedRpRegion || legatRepresentativeRequest.contactCountryRegion) {
      const region = selectedRpRegion ? selectedRpRegion.toString() : legatRepresentativeRequest.contactCountryRegion?.toString() || null
      const found = regions.find((r: Region) => r.name === region)
      setRpProvinceOptions(found ? found.provinces.map((p: Province) => ({ value: p.code, label: p.name })) : [])
    } else {
      setRpProvinceOptions([])
    }
  }, [selectedRpRegion])

  useEffect(() => {
    if (selectedRpProvince || legatRepresentativeRequest.contactProvince) {
      const province = selectedRpProvince ? selectedRpProvince.toString() : legatRepresentativeRequest.contactProvince?.toString() || null
      const comuni = provinceComuniMap.get(province!) || []
      setRpComuneOptions(comuni.map((c: string) => ({ value: c, label: c })))
    } else {
      setRpComuneOptions([])
    }
  }, [selectedRpProvince])


  return (
    <div className="flex flex-col gap-4">
      <MadfarmInput
        required
        label="Indirizzo"
        placeholder="Indirizzo"
        error={!!legalRapresentativeState.legalRepresentativeCreateErrors.contactAddress}
        supportingText={legalRapresentativeState.legalRepresentativeCreateErrors.contactAddress}
        defaultValue={legatRepresentativeRequest.contactAddress}
        onChangeText={(text) => {
          if (mode === "create")
            dispatch(setLegalRepresentativeCreateRequestField({ field: "contactAddress", value: text }))
          else
            dispatch(setLegalRepresentativeUpdateRequestField({ field: "contactAddress", value: text }))
        }}
      />
      <div className="grid grid-cols-2 gap-4">
        <MadfarmStaticSelect
          required
          customZIndex={9999}
          label="Regione"
          noOptionsMessage="Nessuna regione trovata"
          error={!!legalRapresentativeState.legalRepresentativeCreateErrors.contactCountryRegion}
          errorLabel={legalRapresentativeState.legalRepresentativeCreateErrors.contactCountryRegion}
          value={legatRepresentativeRequest.contactCountryRegion}
          placeholder="Regione"
          options={regionOptions}
          onChange={(value) => {
            // @ts-ignore
            const newValue = value !== null ? value.value : null
            handleRpRegionChange(newValue as unknown as OptionType | null)
            if (mode === "create")
              dispatch(setLegalRepresentativeCreateRequestField({ field: "contactCountryRegion", value: newValue }))
            else
              dispatch(setLegalRepresentativeUpdateRequestField({ field: "contactCountryRegion", value: newValue }))
          }}
        />
        <MadfarmStaticSelect
          customZIndex={9999}
          required
          label="Provincia"
          noOptionsMessage="Nessuna provincia trovata"
          error={!!legalRapresentativeState.legalRepresentativeCreateErrors.contactProvince}
          errorLabel={legalRapresentativeState.legalRepresentativeCreateErrors.contactProvince}
          value={legatRepresentativeRequest.contactProvince}
          placeholder="Provincia"
          options={rpProvinceOptions}
          onChange={(value) => {
            // @ts-ignore
            const newValue = value !== null ? value.value : null
            handleRpProvinceChange(newValue as unknown as OptionType | null)
            if (mode === "create")
              dispatch(setLegalRepresentativeCreateRequestField({ field: "contactProvince", value: newValue }))
            else
              dispatch(setLegalRepresentativeUpdateRequestField({ field: "contactProvince", value: newValue }))
          }}
        />
      </div>
      <div className="grid grid-cols-2 gap-4">
        <MadfarmStaticSelect
          customZIndex={9999}
          required
          label="Comune"
          noOptionsMessage="Nessun comune trovato"
          error={!!legalRapresentativeState.legalRepresentativeCreateErrors.contactCity}
          errorLabel={legalRapresentativeState.legalRepresentativeCreateErrors.contactCity}
          value={legatRepresentativeRequest.contactCity}
          placeholder="Comune"
          options={rpComuneOptions}
          onChange={(value) => {
            // @ts-ignore
            const newValue = value !== null ? value.value : null
            if (mode === "create")
              dispatch(setLegalRepresentativeCreateRequestField({ field: "contactCity", value: newValue }))
            else
              dispatch(setLegalRepresentativeUpdateRequestField({ field: "contactCity", value: newValue }))
          }}
        />
        <MadfarmInput
          required
          label="CAP"
          placeholder="CAP"
          error={!!legalRapresentativeState.legalRepresentativeCreateErrors.contactZipCode}
          supportingText={legalRapresentativeState.legalRepresentativeCreateErrors.contactZipCode}
          defaultValue={legatRepresentativeRequest.contactZipCode}
          onChangeText={(text) => {
            if (mode === "create")
              dispatch(setLegalRepresentativeCreateRequestField({ field: "contactZipCode", value: text }))
            else
              dispatch(setLegalRepresentativeUpdateRequestField({ field: "contactZipCode", value: text }))
          }}
        />
      </div>
    </div>
  )
}